module.exports = __webpack_public_path__ + "static/media/alan_nguyen.48642aee.png";